import { inject, Service } from "@angular/core";

import { Constants } from "../constants/constants";
import { PageMode } from "../constants/enums";
import { IntegrityRuleSet, IntegrityTable, MainResponseModel, ObjectType } from "../models";
import { MainService } from ".";

@Service()
export class IntegrityApiService {
  private _mainService = inject(MainService);

  public getTables(id: number) {
    const url = `integrity/getTables/${id}`;

    return this._mainService.sendRequest<MainResponseModel<IntegrityTable[]>>({
      method: "GET",
      url,
      data: {},
    });
  }

  public updateRuleset(data: IntegrityRuleSet, pageMode: PageMode) {
    const url = `integrity/${pageMode === PageMode.create ? "create" : "update"}?isFinish=true`;

    return this._mainService.sendRequest<MainResponseModel<IntegrityTable[]>>({
      method: "POST",
      url,
      data,
    });
  }

  public getRuleSet(id: number) {
    const url = `integrity/getbyid/${id}`;

    return this._mainService.sendRequest<MainResponseModel<IntegrityRuleSet>>({
      method: "GET",
      url,
    });
  }

  public deleteRuleSet(id: number) {
    const url = `integrity/deletebyid/${id}`;

    return this._mainService.sendRequest<MainResponseModel<null>>({
      method: "DELETE",
      url,
    });
  }

  public getFields(id: number) {
    const url = `integrity/getFields/${Constants.CONSTANT_INTEGRITY_TABLES_VALUE_CHECK}?tableId=${id}`;

    return this._mainService.sendRequest<MainResponseModel<IntegrityTable[]>>({
      method: "GET",
      url,
    });
  }

  public getObjectTypes() {
    const url = "integrity/getObjectTypes";

    return this._mainService.sendRequest<MainResponseModel<ObjectType[]>>({
      method: "GET",
      url,
    });
  }
}
